import React, { memo } from 'react';
import classNames from 'classnames/bind';
import AppBadges from '../AppBadges/AppBadges';
import styles from './stepDescription.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(function StepDescription(props) {
    return (
        <div
            className={conditionalStyles({
                backgroundContainer: true,
                generalBackground: props.activeStep === 2,
                networkingBackground: props.activeStep === 3,
                usersBackground: props.activeStep === 4,
                trunksBackground: props.activeStep === 5,
                summaryBackground: props.activeStep === 6,
                qrBackground: props.activeStep === 7,
                licenceBackground: props.activeStep === 8
            })}
        >
            <div className={styles.contentContainer}>
                <div
                    className={conditionalStyles({
                        textContainer: !props.isQRActiveStep,
                        smallTextContainer: props.isQRActiveStep
                    })}
                >
                    <span>
                        {props.activeStepDescription.split(' ').map((statement, index) => {
                            return statement
                                ?
                                <div key={index}>
                                    &bull; {props.t(`wizard:${statement.replace(/ /g, '')}`)}
                                    <br />
                                    <br />
                                </div>
                                :
                                null
                        })}
                    </span>
                </div>
                {props.isQRActiveStep && <AppBadges />}
            </div>
        </div>
    );
});
